export const MODALS = {
  CREATE_SUBACCOUNT: 'createSubaccount',
}
